<script lang="ts">
  import { getContainerContext } from '@athena-lib/container-context.svelte';
  import clsx from 'clsx';
  import { getImageContext } from './context';
  import { generatePictureSources } from './utils';
  import type { ImageProps } from './types';

  const containerContext = getContainerContext();
  const imageContext = getImageContext();

  const {
    src,
    alt,
    action,
    actionArg,
    class: className,
    imgClass,
    widthOfContainer,
    ...restProps
  }: ImageProps = $props();

  const sizes = imageContext?.imageSizeParser?.(src);
  const [width, height] = [sizes?.width, sizes?.height];

  function elementAction(node: HTMLElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

{#if containerContext && imageContext?.imageResizingUrlProvider && sizes}
  <picture use:elementAction class={className}>
    {#each generatePictureSources(src, imageContext.imageResizingUrlProvider, containerContext, widthOfContainer) as source}
      <source
        media={source.media}
        srcset={source.srcset}
        data-estimated-width={source.estimatedWidth}
      />
    {/each}
    <img
      {src}
      fetchpriority={restProps.loading === 'eager' ? 'high' : 'auto'}
      class={imgClass}
      draggable="false"
      {alt}
      {width}
      {height}
      {...restProps}
    />
  </picture>
{:else}
  <img
    src={imageContext?.imageOptimizationUrlProvider?.(src) ?? src}
    class={clsx(className, imgClass)}
    fetchpriority={restProps.loading === 'eager' ? 'high' : 'auto'}
    draggable="false"
    {alt}
    {width}
    {height}
    {...restProps}
    use:elementAction
  />
{/if}
